module.exports = __webpack_public_path__ + "static/media/trinet.c7d8cf1c.svg";